import Vue from 'vue'
import Router from 'vue-router'
import store from './store'
import i18n from './i18n'


Vue.use(Router);

const router = new Router({
    mode: 'history',
    base: process.env.BASE_URL,
    routes: [
        /**
         * Main Routes
         */
        {
            path: '/',
            name: 'home',
            component: () => import('./views/Home.vue'),
            props: {
                title: i18n.t("general.home"),
            },
            meta: {
                auth: true,
            }
        },
        {
            path: '/login',
            name: 'login',
            component: () => import('./views/Login.vue'),
            meta: {
                guest: true,
            }
        },
        {
            path: '/forgot-password',
            name: 'forgotPassword',
            component: () => import('./views/ForgotPassword.vue'),
            meta: {
                guest: true,
            }
        },
        {
            path: '/password-reset/:token',
            name: 'password-reset',
            component: () => import('./views/ResetPassword.vue'),
            props: true,
            meta: {
                guest: true,
            }
        },

        /**
         * Settings Routes
         */
        {
            path: '/settings/app-settings',
            name: 'app_settings',
            component: () => import('./views/AppSettings.vue'),
            props: {
                title: i18n.t('general.app_settings')
            },
            meta: {
                auth: true,
                group: 'settings'
            }
        },
        {
            path: '/settings/clients',
            name: 'settings_clients',
            component: () => import('./views/Settings.vue'),
            props: {
                title: i18n.t('settings.clientsList')
            },
            meta: {
                auth: true,
                group: 'settings'
            }
        },
        {
            path: '/settings/projects',
            name: 'settings_projects',
            component: () => import('./views/Settings.vue'),
            props: {
                title: i18n.t('settings.projectsList')
            },
            meta: {
                auth: true,
                group: 'settings'
            }
        },
        {
            path: '/settings/users',
            name: 'settings_users',
            component: () => import('./views/Settings.vue'),
            props: {
                title: i18n.t('settings.usersList')
            },
            meta: {
                auth: true,
                group: 'settings'
            }
        },
        {
            path: '/settings/bank-accounts',
            name: 'settings_accounts',
            component: () => import('./views/Settings.vue'),
            props: {
                title: i18n.t('bank_accounts.list')
            },
            meta: {
                auth: true,
                group: 'settings'
            }
        },

        /**
         * Work Hours Routes
         */
        {
            path: '/work-hours/create',
            name: 'create_work_hours',
            component: () => import('./views/CreateWorkHours.vue'),
            props: {
                title: i18n.t("general.create_work_hour"),
            },
            meta: {
                auth: true
            }
        },
        {
            path: '/work-hours/edit/:work_hour_id',
            name: 'edit_work_hours',
            component: () => import('./views/CreateWorkHours.vue'),
            props: (route) => ({
                work_hour_id: route.params.work_hour_id,
                title: i18n.t("general.edit_work_hour")
            }),
            meta: {
                auth: true
            }
        },
        {
            path: '/work-hours/repeat/:work_hour_id',
            name: 'repeat_work_hours',
            component: () => import('./views/CreateWorkHours.vue'),
            props: (route) => ({
                work_hour_id: route.params.work_hour_id,
                title: i18n.t("general.repeat_work_hour")
            }),
            meta: {
                auth: true
            }
        },
        {
            path: '/work-hours/view',
            name: 'view_work_hours',
            component: () => import('./views/ViewWorkHours.vue'),
            props: {
                title: i18n.t("settings.viewWorkHours"),
            },
            meta: {
                auth: true
            }
        },

        /**
         * Invoices Routes
         */
        {
            path: '/invoices/create',
            name: 'create_invoices',
            component: () => import('./views/CreateInvoices.vue'),
            props: {
                title: i18n.t('invoices.create')
            },
            meta: {
                auth: true
            }
        },
        {
            path: '/invoices/edit/:item_id',
            name: 'edit_invoices',
            component: () => import('./views/CreateInvoices.vue'),
            props: (route) => ({
                item_id: route.params.item_id,
                title: i18n.t('invoices.edit')
            }),
            meta: {
                auth: true
            }
        },
        {
            path: '/invoices/repeat/:item_id',
            name: 'repeat_invoices',
            component: () => import('./views/CreateInvoices.vue'),
            props: (route) => ({
                item_id: route.params.item_id,
                title: i18n.t('invoices.repeat')
            }),
            meta: {
                auth: true
            }
        },
        {
            path: '/invoices/view',
            name: 'view_invoices',
            component: () => import('./views/ViewInvoices.vue'),
            props: {
                title: i18n.t('invoices.plural'),
            },
            meta: {
                auth: true
            }
        },
    ]
});

/**
 * Build authentication middleware
 */
router.beforeEach((to, from, next) => {
    const isGuest = to.matched.some(record => record.meta.guest);
    const isAuth = to.matched.some(record => record.meta.auth);
    const loggedIn = store.getters.isAuthenticated;

    // If guest tries to access page that requires authentication,
    // redirect to login page.
    if (!loggedIn && isAuth) {
        return next({
            path: '/login',
            query: {redirect: to.fullPath}
        });
    }

    // If user already logged in, prevent him from accessing login page.
    if (loggedIn && isGuest) {
        return next('/');
    }

    next();
});

export default router;
